<ion-header>
  <ion-toolbar class="modal-header">
    <div class="modal-title">
      <h3>Create Triage Thread</h3>
    </div>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        color="dark"
        (click)="shouldCreateChannel = !shouldCreateChannel"
        class="btn-small"
        style="height: 24px; margin-left: auto; margin-right: 8px"
      >
        <ion-icon [name]="shouldCreateChannel ? 'checkbox' : 'square-outline'" class="padded-icon"></ion-icon>
        Create temporary channel
      </ion-button>
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-list lines="none" class="no-padding">
    <ion-item [hidden]="shouldCreateChannel">
      <ion-label slot="start">Channel</ion-label>
      <app-channel-selector
        [channel]="channel"
        (channelDidChange)="onSlackChannelChanged($event)"
        [defaultInternalOnly]="true"
        [hideLinkedToText]="true"
        initialButtonText="Choose a channel to post"
      ></app-channel-selector>
    </ion-item>
    <ion-item *ngIf="shouldCreateChannel">
      <ion-label slot="start">Channel name prefix</ion-label>
      <ion-input
        class="input-field"
        placeholder="Conversation ID will be appended"
        style="margin: 0; height: 34px"
        [(ngModel)]="channelNamePrefix"
      ></ion-input>
    </ion-item>
    <ion-item *ngIf="shouldCreateChannel">
      <ion-label slot="start">Channel visibility</ion-label>
      <ion-select
        class="select-outline"
        interface="popover"
        [(ngModel)]="isChannelPrivate"
        [compareWith]="visibilityCompareFn"
      >
        <ion-select-option [value]="false">Public</ion-select-option>
        <ion-select-option [value]="true">Private</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-label slot="start">Mention a user (optional)</ion-label>
      <ion-chip
        style="margin: 0"
        mode="ios"
        class="select-chip select-outline"
        [outline]="true"
        (click)="showAssigneeOptions()"
      >
        <ion-label>
          {{ mentionLabel ?? 'None' }}
          <ion-icon name="chevron-down-outline" part="icon" class="icon-padded-left button-icon"></ion-icon>
        </ion-label>
      </ion-chip>
    </ion-item>
    <ion-item>
      <ion-label slot="start"> Message (optional) </ion-label>
      <ion-textarea
        #markdownInput
        lines="8"
        autoGrow="true"
        placeholder="e.g. Hey can you take a look at this?"
        [(ngModel)]="message"
        class="input-field"
      >
      </ion-textarea>
    </ion-item>
  </ion-list>
  <div style="padding: 0 18px 18px 0" class="flex-space-between">
    <ion-button fill="clear" class="btn-small" href="https://docs.unthread.io/conversations/triaging" target="_blank">
      <ion-icon name="book-outline" class="padded-icon"></ion-icon>
      <span class="hidden-sm">Learn more about triaging</span>
    </ion-button>
    <ion-button [disabled]="isLoading" (click)="triage()">
      Post to channel
      <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
      <ion-icon name="arrow-forward-outline" class="icon-padded-left button-icon" [hidden]="isLoading"></ion-icon>
    </ion-button>
  </div>
</ion-header>
